import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    overflowX: 'auto',
  },
  row: {
    '&:hover': {
      backgroundColor: '#f9f9f9',
    },
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    marginRight: 8,
    width: 32,
    height: 32,
  },
  name: {
    fontSize: 14,
    fontWeight: 500,
    color: '#333',
  },
  paginationWrapper: {
    display: 'flex',
    justifyContent: 'flex-end', // alinha à esquerda
    padding: '1rem 0',
  },

  paginationLeft: {
    marginLeft: '0.5rem', // opcional: afasta da borda esquerda
  },
}));
